export default function MerchantProjectsModal({ open, onClose, merchant }) {
  if (!open || !merchant) return null;
  const projects = merchant.projects || [];
  return (
    <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4" onClick={onClose}>
      <div className="bg-white rounded-xl w-full max-w-lg p-6" onClick={(e) => e.stopPropagation()}>
        <h3 className="text-lg font-bold mb-4">Proyectos: {merchant.company_name}</h3>
        {projects.length > 0 ? (
          <div className="space-y-2">
            {projects.map((p) => (
              <div key={p.project_id} className="p-3 bg-gray-50 rounded-lg text-sm">
                <div className="font-medium">{p.project_name}</div>
                <div className="text-xs text-gray-500 mt-1">ID: {p.project_id} | Fee: {p.fee_percentage}%</div>
              </div>
            ))}
          </div>
        ) : <p className="text-gray-500">Sin proyectos</p>}
        <div className="flex justify-end mt-4">
          <button onClick={onClose} className="px-4 py-2 text-sm border rounded-lg">Cerrar</button>
        </div>
      </div>
    </div>
  );
}
